import React from "react";
import Image from "components/image";
import { trackSelectItem } from "analytics";
import { useCustomer } from "hooks/useStore";
import Link from "components/link";
import getProductUrl from "utils/product-url";
import { ReactComponent as Arrow } from "svgs/light-right-arrow.svg";
import clsx from "clsx";

const Minimalistic = ({ product, index }) => {
	const customer = useCustomer();

	const { handle, title, variants, variant, previewImages } = product || {};

	const handleProductClick = (event) => {
		event.stopPropagation();
		trackSelectItem({ ...product, index }, customer);
	};

	return (
		<Link
			to={getProductUrl({ handle, variant, variants })}
			onClick={handleProductClick}
			onKeyDown={(e) => e.key === "Enter" && handleProductClick(e)}
			tabIndex={0}
			aria-label={`View ${title}`}
			className={clsx("minimalistic-collection group/card flex animate-blurIn flex-col gap-1")}>
			<div className={clsx("relative flex w-full overflow-hidden")}>
				<Image className="img-transition-scale" image={previewImages[0]} />
				<div className="absolute bottom-0 left-0 w-full p-2 pb-3 bg-gradient-to-t 
						from-black/90 via-black/40 to-transparent text-white">
					<div className="flex items-end justify-between w-full">
						<div className="flex flex-col gap-0 max-w-[85%]">
							<h5 className="text-left font-bold text-xl leading-normal">{product.title}</h5>
							{product?.type && (
								<h5 className="text-xxs font-base text-left capitalize md:text-xs leading-normal">
									{product.type}
								</h5>
							)}
						</div>
						<button className="collection-button max-w-1/4 justify-center">
							<Arrow className=" w-4 h-4 fill-black" />
						</button>
					</div>
				</div>
			</div>
		</Link>
	);
};

export default Minimalistic;
